module.exports = __webpack_public_path__ + "img/pic_home_case_0.79c86c4a.png";